import React, { PropTypes } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { currentAccountSelector } from '../../selectors/AuthSelector';
import SearchActions from '../../actions/SearchActions';
import DocumentHeadContainer from '../DocumentHeadContainer';
import { getCurrentHolds, getPagination, getHoldsStatus } from '../../selectors/HoldsSelector';
import * as HoldActions from '../../actions/HoldActions';
import HoldsPrintList from '../../components/borrowing/holds/HoldsPrintList';

class PrintHoldsContainer extends BcReactComponent {
  static fetchInitialData(params, query, store) {
    const account = currentAccountSelector(store.getState());
    const accountId = account && account.get('id');

    return [store.dispatch(HoldActions.fetchHolds({ accountId, ...params, ...query }))];
  }

  componentWillUpdate(nextProps) {
    const { location } = this.props;

    if (location.search !== nextProps.location.search) {
      this.props.holdActions.fetchHolds({
        accountId: nextProps.accountId,
        ...nextProps.router.params,
        ...nextProps.location.query
      });
    }
  }

  render() {
    const { intl, ...props } = this.props;
    return (
      <div className="cp-print-list">
        <DocumentHeadContainer pageTitle={intl.formatMessage({ id: 'section_title_holds' })} />
        <HoldsPrintList {...props} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const items = getCurrentHolds(state, ownProps);
  const pagination = getPagination(state, ownProps);
  const holdsStatus = getHoldsStatus(state);
  const isFetching = holdsStatus.get('fetching', false);
  const account = currentAccountSelector(state);
  const accountId = account && account.get('id');

  return {
    items,
    pagination,
    isFetching,
    accountId
  };
};


const mapDispatchToProps = dispatch => ({
  searchActions: bindActionCreators(SearchActions, dispatch),
  holdActions: bindActionCreators(HoldActions, dispatch)
});

PrintHoldsContainer.propTypes = {
  intl: intlShape,
  items: ImmutablePropTypes.list,
  accountId: PropTypes.number
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PrintHoldsContainer));



// WEBPACK FOOTER //
// ./app/containers/print/PrintHoldsContainer.jsx